// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    userRoleList: [],
    privilageList: [],
    selectedUserRole: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'userRole',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setUserRoles(state, action) {
            state.userRoleList = action.payload;
        },
        setPrivilages(state, action) {
            state.privilageList = action.payload;
        },
        setSelectedUserRole(state, action) {
            state.selectedUserRole = action.payload;
        },
        setUserRole(state, action) {
            const data = action.payload;
            const rowIndex = state.userRoleList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.userRoleList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedUserRole } = slice.actions;
// ----------------------------------------------------------------------

export function getUserRoles() {
    return async () => {
        try {
            const response = await axios.post('/user_role/list');
            if (response.data.status) {
                dispatch(slice.actions.setUserRoles(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getUserRole(id) {
    return async () => {
        try {
            const response = await axios.post('/user_role/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setUserRole(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function saveUserRole(data) {
    return async function () {
        const response = await axios.post('user_role/save', data);
        return response;
    };
}

export function updateUserRole(data) {
    return async function () {
        const response = await axios.post('user_role/update', data);
        return response;
    };
}

export function deleteUserRole(data) {
    return async function () {
        const response = await axios.post('user_role/delete', data);
        return response;
    };
}
export function getPrivilages() {
    return async () => {
        try {
            const response = await axios.post('/user_role/privilage/list');
            if (response.data.status) {
                dispatch(slice.actions.setPrivilages(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
